import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useStyles } from 'src/features/Advisors/Applications/SummaryMortgage/SummaryMortgageLanding.styles'
import Button from 'src/components/Buttons/Button';
import { useHistory } from 'react-router-dom';
import { equals, lte, not, pathOr } from 'ramda';
import Countdown from 'react-countdown';
import UserManageLoader from 'src/features/Auth/Login/UserManageLoader';
import { getPermissionByRoles } from 'src/features/RBAC/permissions';
import useAccounts from 'src/hooks/useAccountsHook';
import { TRUE } from 'src/constants';
import { LOG_OUT } from "src/route_constants";


interface Props { }
type CombinedProps = Props
const LogoutModal: React.FC<CombinedProps> = (props: CombinedProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const { accountRoles, enableTimeout } = useAccounts();
  const { permissions, isLoading }: any = getPermissionByRoles(accountRoles)

  const manageLoginTime = new UserManageLoader(permissions);
  useEffect(() => {
    if (equals(TRUE, enableTimeout) && not(isLoading)) {
      const interval = setInterval(() => {
        setOpen(manageLoginTime.checkSessionTimeoutWarning());
        if (manageLoginTime.checkSessionTimeout()) {
          handleLogout()
        }
      }, 1000)
      return () => {
        clearInterval(interval)
      }
    }
  
    return;
  });

  const handleSubmit = () => {
    setOpen(false);
    // ================================================================
    // TODO: Update session's login time on  authentication_methods
    manageLoginTime.setLoggedInTime();
  }
  const handleLogout = () => {
    history.push(LOG_OUT)
  }
  const expiredTime = Number(pathOr('0', ['timeout', 'expired'], manageLoginTime.getTimeoutDetails())) / 60;
  const renderer = ({ minutes, seconds, completed }: any) => {
    const currentSeconds = lte(seconds, 9) ? `0${seconds}` : seconds
    if (completed) {
      handleLogout();
      return <></>;
    } else {
      return <>{`We'll sign you out in ${minutes}:${currentSeconds}`}</>;
    }
  };
  return (
    <Dialog open={open} maxWidth={'sm'} fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        <Countdown
          date={Date.now() + manageLoginTime.getRemainingTime()}
          renderer={renderer}
        />
      </DialogTitle>
      <DialogContent>
        {`We'll sign you out when you are inactive for ${expiredTime} hour`}
      </DialogContent>
      <DialogActions className={classes.btnActionContainer}>
        <Button
          px={40}
          py={12}
          text='Log out'
          variant='outlined'
          onClick={handleLogout}
          className={classes.footerBtn}
        />
        <Button
          px={40}
          py={12}
          text='I need more time'
          onClick={handleSubmit}
          className={classes.footerBtn}
        />
      </DialogActions>
    </Dialog>
  )
}
export default LogoutModal;
